module.exports = __webpack_public_path__ + "img/For you.d15809a6.png";